<ng-template [ngIf]="projectsSupported">

  <ngx-hm-carousel
    [(ngModel)]="currentIndex"
    show-num="auto"
    [breakpoint]="breakpoints"
    [autoplay]="autoplay"
    [autoplay-speed]="speed"
    [autoplay-direction]="direction"
    [infinite]="infinite"
    [drag-many]="true"
    [mouse-enable]="mouseEnable"
    [aniTime]="200"
    [data]="projectsSupported"
    class="carousel c-accent">

    <section ngx-hm-carousel-container class="content">
      <article class="item cursor-pointer"
               ngx-hm-carousel-item
               *ngFor="let project of projectsSupported; let i = index">
        <a [routerLink]="['/', currentLanguage, RouterUrls.BrowseProjects, project.slug]" class="project-bubble">
          <div class="image-wrapper">
            <img loading="lazy" src="{{project.picture_thumbnail}}" alt="project-picture">
          </div>
          <div class="project-title">{{project.name[currentLanguage]}}</div>
        </a>
      </article>
      <ng-template #infiniteContainer></ng-template>
    </section>

    <!-- only using in infinite mode or autoplay mode, that will render with-->
      <ng-template #carouselContent let-project let-i="index">
        <article class="item cursor-pointer">
          <a [routerLink]="['/', currentLanguage, RouterUrls.BrowseProjects, project.slug]" class="project-bubble">
            <div class="image-wrapper">
              <img loading="lazy" src="{{project.picture_thumbnail}}">
            </div>
            <div class="project-title">{{project.name[currentLanguage]}}</div>
          </a>
        </article>
      </ng-template>

    <ng-template #carouselPrev>
      <div class="click-area">
        <img loading="lazy" class="rotate-180" src="/assets/icons/arrow-in-circle-green.svg" alt="previous">
      </div>
    </ng-template>
    <ng-template #carouselNext>
      <div class="click-area">
        <img loading="lazy" src="/assets/icons/arrow-in-circle-green.svg" alt="next">
      </div>
    </ng-template>
  </ngx-hm-carousel>
</ng-template>
